import { render, staticRenderFns } from "./UpdateRecords.vue?vue&type=template&id=62a74af6&scoped=true"
import script from "./UpdateRecords.vue?vue&type=script&lang=js"
export * from "./UpdateRecords.vue?vue&type=script&lang=js"
import style0 from "./UpdateRecords.vue?vue&type=style&index=0&id=62a74af6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a74af6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62a74af6')) {
      api.createRecord('62a74af6', component.options)
    } else {
      api.reload('62a74af6', component.options)
    }
    module.hot.accept("./UpdateRecords.vue?vue&type=template&id=62a74af6&scoped=true", function () {
      api.rerender('62a74af6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/data/UpdateRecords.vue"
export default component.exports